export const WAD = {
  bigint: BigInt(1e18),
  number: 1e18,
}

export function calculateRedeemAmount(amount: bigint, exchangeRate: bigint, slippage: number): bigint {
  if (exchangeRate === BigInt(0)) {
    return BigInt(0)
  }
  const baseAmount = (amount * WAD.bigint) / exchangeRate
  const slippageAsBigInt = BigInt((slippage * WAD.number).toString())
  const slippageAmount = (baseAmount * slippageAsBigInt) / WAD.bigint
  return baseAmount - slippageAmount
}
